import { useLocation } from "react-router-dom";
import {
  SearchScopeSchema,
  type SearchScope,
  type SearchScopeValue,
} from "../types";

export function useSearchScope(roomId: string | null): SearchScope {
  const location = useLocation();
  const raw = new URLSearchParams(location.search).get("scope");
  const parsed: SearchScopeValue = SearchScopeSchema.parse(raw ?? "room");
  if (roomId === null) return { kind: "global" };
  if (parsed === "global") return { kind: "global" };
  return { kind: "room", roomId };
}
